import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { useCallback } from 'react';

const useTrackEvent = () => {
    const appInsCtx = useAppInsightsContext();

    return useCallback(
        (name: string, properties?: Record<string, unknown>) => {
            const appInsights = appInsCtx.getAppInsights();
            appInsights.trackEvent({
                name,
                properties
            });
        },
        [appInsCtx]
    );
};

export default useTrackEvent;
